import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.permissionList),function(perm){return _c(VChip,{key:perm,staticClass:"ml-1 mb-1 text-capitalize",attrs:{"dark":"","outlined":!_vm.permissions[perm],"color":_vm.permColor(perm)},on:{"click":function($event){return _vm.togglePermission(perm)}}},[_vm._v(" "+_vm._s(_vm.label(perm))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }